import ReactPaginate from "react-paginate";

const Pagination = ({ totalItems, itemsPerPage, onPageChange, currentPage }) => {
  const totalPages = Math.ceil(totalItems / itemsPerPage);

  if(totalPages <= 1) return null;

  return (
    <div className="pagination-container">
      {/* <ul>
        {Array.from({ length: totalPages }, (_, index) => index + 1).map((page) => (
          <li key={page} className={currentPage === page ? "active-btn" : "pageChange-btn"}>
            <button onClick={() => handlePageChange(page)}>{page}</button>
          </li>
        ))}
      </ul> */}
      <ReactPaginate
        forcePage={currentPage - 1}
        breakLabel="..."
        onPageChange={onPageChange}
        pageRangeDisplayed={2}
        pageLinkClassName="pageChange-btn"
        previousLinkClassName="next-previous"
        nextLinkClassName="next-previous"
        activeLinkClassName="active-btn"
        breakClassName="break-btn"
        pageCount={totalPages}
        renderOnZeroPageCount={null}
      />
    </div>
  );
};

export default Pagination;
